import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import type { UnitResource } from "@exonn/js-sdk";

export const module: ModuleOptions<UnitResource> = {
  resource: ResourceEnum.Unit,
  bigIcon: <i className="icon-20-units_adm" />,
  smallIcon: <i className="icon-15-units_adm" />,
};
